import * as React from "react";

const GreenMark = (props: any) => (
  <svg
    width={81}
    height={200}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 1.24C8.457-1.13 17.82-.069 25.533 4.136c7.713 4.205 13.688 11.504 16.29 19.904 1.649 5.314 2.01 11.05 4.437 16.057 4.071 8.396 13.002 13.06 19.823 19.422C80.7 73.15 85.222 96.501 76.753 114.618c-6.083 13.015-17.696 22.653-24.69 35.2a56.782 56.782 0 0 0-6.294 17.663c-.734 4.125-1.022 8.376-2.521 12.287-2.272 5.928-7.14 10.525-12.493 13.928-8.414 5.35-19.067 8.199-28.468 4.887-1.053-.37-2.02-2.068-.92-2.248L0 1.24Z"
      fill="#02DE7F"
    />
  </svg>
);

export default GreenMark;
